import { render, staticRenderFns } from "./TagChange.vue?vue&type=template&id=5796cc53"
import script from "./TagChange.vue?vue&type=script&lang=js"
export * from "./TagChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports